/**
 * @type {{
 *  code: String,
 *  caption: String
 * }[]}
 */
export const LocaleConfig = [
  {
    code: "EN",
    caption: "EN",
  },
  {
    code: "TC",
    caption: "繁",
  }
];